
import { useProfileState } from "@/hooks/useProfileState";
import { useProfileData } from "@/hooks/useProfileData";
import { useProfileForm } from "@/hooks/useProfileForm";

/**
 * Main profile hook that combines profile state, data fetching, and form handling
 */
export const useProfile = () => {
  const {
    profile,
    setProfile,
    loading,
    setLoading,
    uploading,
    setUploading,
    activeTab,
    setActiveTab,
    isProfileComplete
  } = useProfileState();

  const { loadProfile } = useProfileData(setProfile, setLoading);
  
  const { handleChange, handleSubmit, handleImageUpload, autoSaved, savingState } = useProfileForm(
    profile,
    setProfile,
    setUploading
  );

  return { 
    profile, 
    loading, 
    uploading, 
    activeTab, 
    setActiveTab, 
    handleChange, 
    handleSubmit,
    handleImageUpload,
    isProfileComplete,
    loadProfile,
    autoSaved,
    savingState
  };
};
